/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:51:23
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-16 10:02:24
 * @FilePath: \monitor\src\language\report\index.js
 * @Description: 
 */
import Daily from "./daily";
import Query from "./query";
import From from "./from";
const CN = {
  Daily: Daily.CN,
  Query: Query.CN,
  From: From.CN,
};
const EN = {
  Daily: Daily.EN,
  Query: Query.EN,
  From: From.EN,
};
export default {
  CN,
  EN
};



// WEBPACK FOOTER //
// ./src/language/report/index.js